import CustomComponent from "../../components/customComponent";
import { withRouter } from "../../components/withRouter";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import { withToast } from "../../App";
import LoadingOverlay from "../../components/LoadingOverlay";
import { FormInput, FormCheckBox } from "../../components/FormComponents";
import { LoginLayout } from "../../components/Layouts";
import { REGEX } from "../../helpers/validation";
import { clearCmsStorage } from "../../helpers/storageUtils";

class Login extends CustomComponent {
    constructor(props) {
        super(props);
        this.state = {
            login: {
                email: "",
                password: "",
                remember_me: true,
            },
            formIsValid: false,
            isLoading: false,
        };
        this._isMounted = false;
    }

    componentDidMount() {
        this.checkIsConnectedPWA();
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    checkFormValidity = () => {
        this.setState({
            formIsValid:
                new RegExp(REGEX.email).test(this.state.login.email) &&
                this.state.login.password !== "",
        });
    };

    async login(csrf_token) {
        const { t } = this.props;
        let url = "/login";
        let method = "POST";
        let body = JSON.stringify({
            email: this.state.login.email,
            password: this.state.login.password,
            _remember_me: this.state.login.remember_me,
            _csrf_token: csrf_token,
        });
        let data = await this.request(url, method, body);

        if (data) {
            if (data.status === "ok") {
                let isServiceWorkerUpdated = localStorage.getItem(
                    "isServiceWorkerUpdated",
                )
                    ? true
                    : false;
                clearCmsStorage(); // clear CMS session data
                if (isServiceWorkerUpdated)
                    localStorage.setItem("isServiceWorkerUpdated", "true");
                localStorage.setItem(
                    "_remember_me",
                    JSON.stringify(this.state.login.remember_me),
                );
                this.props.onRolesLoad(data.roles); // send roles to navigation
                await this.getAccount(true);
                this.props.addToast(t("Connection successful"), {
                    appearance: "success",
                    autoDismiss: true,
                    autoDismissTimeout: 4000,
                });
                if (data.passwordNeedsChange) {
                    localStorage.setItem("passwordNeedsChange", true);
                    this.props.history.push("/password/edit");
                } else if (data.cguNeedValidation) {
                    localStorage.setItem("cguNeedValidation", true);
                    this.props.history.push("/");
                } else {
                    this.props.history.push("/");
                }
            }
        }
    }

    async afterSubmission(event) {
        this._isMounted && this.setState({ isLoading: true });
        event.preventDefault();
        let csrf = await this.getCsrfToken("/login/csrf");
        await this.login(csrf);
        this._isMounted && this.setState({ isLoading: false });
    }

    render() {
        const { t } = this.props;
        return (
            <LoginLayout>
                <LoadingOverlay
                    active={this.state.isLoading}
                    classNamePrefix="loader_"
                    spinner
                    text={t("loading")}
                ></LoadingOverlay>
                <div className="login__boater">
                    <h2 className="h2">{t("boater_login")}</h2>
                    <p className="">{t("boater_login_description")}</p>
                    <Link
                        to="/boater"
                        className="login__boater__cta vnf-btn vnf-btn-quaternary vnf-btn-quaternary-arrow"
                    >
                        {t("boater_login_cta")}
                    </Link>
                </div>
                <div className="login__form secondary-form">
                    <h2 className="secondary-form__title h2">
                        {t("Identify")}
                    </h2>
                    <form onSubmit={(e) => this.afterSubmission(e)}>
                        <div className="row">
                            <div className="col-12">
                                <FormInput
                                    label={t("Email")}
                                    type="email"
                                    name="email"
                                    id="email"
                                    appearance="secondary"
                                    handle={(e) =>
                                        this.handleInputChange(
                                            e,
                                            null,
                                            "login",
                                            () => this.checkFormValidity(),
                                        )
                                    }
                                    value={this.state.login.email}
                                />
                            </div>
                            <div className="col-12">
                                <FormInput
                                    label={t("Password")}
                                    type="password"
                                    name="password"
                                    id="password"
                                    appearance="secondary"
                                    handle={(e) =>
                                        this.handleInputChange(
                                            e,
                                            null,
                                            "login",
                                            () => this.checkFormValidity(),
                                        )
                                    }
                                    value={this.state.login.password}
                                />
                            </div>
                        </div>
                        <FormCheckBox
                            label={t("remember_me")}
                            name="remember_me"
                            id="remember_me"
                            appearance="secondary"
                            handle={(e) =>
                                this.handleInputChange(e, null, "login")
                            }
                            value={this.state.login.remember_me}
                        />
                        <button
                            type="submit"
                            className="login__boater__cta vnf-btn vnf-btn-quaternary vnf-btn-quaternary-arrow vnf-btn-quaternary--dark-disabled"
                            disabled={
                                this.state.isLoading || !this.state.formIsValid
                            }
                        >
                            {t("Login")}
                        </button>
                    </form>
                    <div className="links">
                        <Link to="/password/reset">
                            {t("Forgot your password ?")}
                        </Link>
                        <Link to="/register">
                            {t("New ? Create an account")}
                        </Link>
                    </div>
                </div>
            </LoginLayout>
        );
    }
}

export default withToast(
    hoistStatics(withTranslation()(withRouter(Login)), Login),
);
